/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import {Button, KIND, SHAPE} from 'baseui/button'
import {OptionProfile, StatefulMenu} from 'baseui/menu'
import {PLACEMENT, StatefulPopover} from 'baseui/popover'
import isString from 'lodash/isString'
import React, {forwardRef} from 'react'
import {useDispatch} from 'react-redux'
import {useFirebase} from 'react-redux-firebase'
import {useHistory} from 'react-router-dom'
import {setNotification} from '../../features/persistence/notification-slice'
import {navigation} from '../../utils/config'

const OptionProfileWithRef = forwardRef((props, ref) => {
  const {overrides, ...rest} = props

  return (
    <OptionProfile
      {...rest}
      overrides={{
        ...overrides,
        ListItemProfile: {
          props: {
            ref,
          },
        },
      }}
    />
  )
})

const HeaderAuthMenu = props => {
  const firebase = useFirebase()
  const dispatch = useDispatch()
  const {children, ...rest} = props
  const history = useHistory()

  const handleLogout = async () => {
    await firebase.logout()
  }

  return (
    <Block display="flex" alignItems="center">
      <StatefulPopover
        content={() => (
          <StatefulMenu
            {...rest}
            items={navigation.large.auth}
            onItemSelect={async ({event, item}) => {
              event.preventDefault()
              if (isString(item.url)) {
                history.push(item.url)
              } else {
                try {
                  await handleLogout()
                } catch (error) {
                  dispatch(
                    setNotification({
                      code: error.code,
                      message: error.message,
                      kind: KIND.negative,
                    }),
                  )
                }
              }
            }}
            overrides={{
              List: {
                style: {},
              },
              Option: {
                component: OptionProfileWithRef,
                props: {
                  getProfileItemLabels: ({title}) => ({
                    title,
                  }),
                  getProfileItemImg: item => item.icon,
                  getProfileItemImgText: item => item.title,
                  overrides: {
                    ListItemProfile: {},
                    ProfileImgContainer: {
                      style: ({$theme}) => ({
                        color: $theme.colors.mono1000,
                        height: 'auto',
                        width: 'auto',
                      }),
                    },
                    ProfileImg: {},
                    ProfileLabelsContainer: {
                      style: ({$theme}) => ({
                        color: $theme.colors.mono1000,
                        marginTop: 'auto',
                        marginBottom: 'auto',
                      }),
                    },
                    ProfileTitle: {},
                    ProfileSubtitle: {},
                    ProfileBody: {},
                  },
                },
              },
            }}
          />
        )}
        placement={PLACEMENT.bottomRight}
      >
        <Button
          kind={KIND.secondary}
          shape={SHAPE.round}
          overrides={{
            BaseButton: {
              style: ({$theme}) => ({
                color: $theme.colors.primary700,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                paddingBottom: 0,
              }),
            },
          }}
        >
          {children}
        </Button>
      </StatefulPopover>
    </Block>
  )
}

export default HeaderAuthMenu
